import React, { useState } from "react";
import { Link } from "react-router-dom";
import Banner from "./Banner";
import Carousel from "react-bootstrap/Carousel";

const Home = () => {
  const [lightboxImg, setLightboxImg] = useState(null); // Lightbox state

  // Slider data
  const slides = [
    { image: "./images/yoga1.jpeg", title: "Celebrating Yoga Day", description: "21 June" },
    { image: "./images/g33.jpeg", title: "World Art Day", description: "15 April" },
    { image: "./images/fa.jpeg", title: "Forest Activity", description: "21 March" },
    { image: "./images/cul.jpeg", title: "Cultural Activity", description: "Yearly" },
  ];

  // Academic/School gallery
  const academicGallery = [
    { title: "Academic Planner", src: "/images/acadmic.jpeg" },
    { title: "Class Room", src: "/images/21.jpeg" },
    { title: "School Magazine", src: "/images/25.jpeg" },
  ];

  // Photo carousel images
  const photoSlides = [
    "/images/1.jpeg", "/images/2.jpeg", "/images/3.jpeg", "/images/4.jpeg", "/images/5.jpeg",
    "/images/6.jpeg", "/images/7.jpeg", "/images/8.jpeg", "/images/9.jpeg", "/images/10.jpeg",
  ];

  return (
    <>
      {/* Banner */}
      <Banner />

      {/* About / Messages / Notices */}
      <div className="content_box">
        {/* About Section */}
        <div className="first_box bxx">
          <div className="bx1">
            <p>About Us</p>
            <h1>Seedling School Bhopal</h1>
          </div>
          <div className="image_boxAb img-school">
            <img src="./school.jpeg" alt="School" />
          </div>
          <div className="para-content">
            <p>
              Seedling School is based in the city of lake Bhopal. Recognized as a developmentally enriching learning space, making learning fun for children. Founded in 1998. <Link to="/ourSchool">Read more</Link>
            </p>
          </div>
        </div>

        {/* Director Message */}
        <div className="second_box bxx">
          <div className="bx1">
            <p>Message</p>
            <h1>Director</h1>
          </div>
          <div className="image_boxAb img-principle">
            <img src="./images/Director.jpeg" alt="Director" />
          </div>
          <div className="para-content">
            <p>
              Dear Parent & Students, welcome to Seedling School. The school is committed to inculcating strong ethical values of integrity and respect. <Link to="/director">Read more</Link>
            </p>
          </div>
        </div>

        {/* Principal Message */}
        <div className="second_box bxx">
          <div className="bx1">
            <p>Message</p>
            <h1>Principal</h1>
          </div>
          <div className="image_boxAb img-principle">
            <img src="./images/Principal.jpeg" alt="Principal" />
          </div>
          <div className="para-content">
            <p>
              Welcome to SSB, a home built on decades of valued traditions. Children learn more from what you are and what you do than what you say. <Link to="/principal">Read more</Link>
            </p>
          </div>
        </div>

        {/* Notice Board */}
        <div className="third_box bxx">
          <div className="bx1">
            <p>Latest From</p>
            <h1>Notice Board</h1>
          </div>
          <div className="image_boxAbc">
            <div className="animatinct">
              <p>1. ADMISSION OPEN FROM PLAYGROUP TO CLASS 8 Session 2026-27</p>
              <p>2. School Transport Arrangement</p>
            </div>
          </div>
        </div>
      </div>

      {/* Academic Gallery */}
      <div className="third_content_box">
        {academicGallery.map((item, idx) => (
          <div className="academic_planner" key={idx}>
            <div className="accontent">
              <p>{item.title}</p>
            </div>
            <div className="imgggbox1" onClick={() => setLightboxImg(item.src)} style={{ cursor: 'pointer' }}>
              <img src={item.src} alt={item.title} />
            </div>
          </div>
        ))}
      </div>

      {/* Lightbox Modal */}
      {lightboxImg && (
        <div
          className="lightboxOverlay"
          onClick={() => setLightboxImg(null)}
          style={{
            position: "fixed",
            top: 0, left: 0,
            width: "100vw",
            height: "100vh",
            background: "rgba(0,0,0,0.9)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 9999,
            cursor: "pointer",
          }}
        >
          <img
            src={lightboxImg}
            alt="Lightbox"
            style={{
              maxWidth: "90%",
              maxHeight: "80%",
              borderRadius: "12px",
              boxShadow: "0 10px 30px rgba(0,0,0,0.5)",
              transition: "transform 0.3s ease",
            }}
          />
        </div>
      )}

      {/* Photo & Video Galleries */}
      <div className="fourth_content_box">
        <div className="fouthmain">
          {/* Photo Gallery */}
          <div className="fourthOne">
            <div className="ffone"><h3>Photo Gallery</h3></div>
            <div className="ffslider">
              <Carousel className="abcd">
                {photoSlides.map((src, idx) => (
                  <Carousel.Item className="jhk" key={idx}>
                    <img className="d-block" src={src} alt={`Slide ${idx + 1}`} />
                  </Carousel.Item>
                ))}
              </Carousel>
            </div>
            <div className="ffbutton">
              <Link to="/gallery"><button>View More</button></Link>
            </div>
          </div>

          {/* Video Gallery */}
          <div className="fourthOne">
            <div className="ffone"><h3>Video Gallery</h3></div>
            <div className="ffslider">
              <iframe
                width="100%"
                height="100%"
                src="https://www.instagram.com/reel/DF7YGKZIWp9/embed"
                frameBorder="0"
                scrolling="no"
                allowTransparency="true"
              ></iframe>
            </div>
            <div className="ffbutton">
              <a href="https://www.instagram.com/reel/DF7YGKZIWp9/?utm_source=ig_web_copy_link" target="_blank" rel="noreferrer">
                <button>View More</button>
              </a>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Home;
